import { ReactElement } from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import CustomFormControl from '../base/CustomFormControl';
import RequiredIndicator from 'pages/ApplicationRequest/components/containers/RequiredIndicator';

/**
 * Prompt user for input: SSN
 * Includes auto-formatting mask to display XXX-XX-XXXX
 * @param {string|ReactElement} helperText default assistive text to display below the field
 * @param {boolean} required if required, display an indicator
 * @param {any} props the rest of the properties to be applied to the field
 * @returns {ReactElement} textfield for SSN user input
 */
const SocialSecurityNumber = ({ helperText, required, ...props }) => {
	const [field, meta] = useField(props);
	return (
		<CustomFormControl>
			<InputMask mask='999-99-9999' maskChar='' {...field}>
				{inputProps => (
					<TextField
						name={props.name}
						variant='outlined'
						label={
							<>
								{required && <RequiredIndicator />}
								Social Security Number (SSN)
							</>
						}
						helperText={
							meta.touched && meta.error ? meta.error : helperText
						}
						error={meta.touched && !!meta.error}
						{...inputProps}
					/>
				)}
			</InputMask>
		</CustomFormControl>
	);
};

SocialSecurityNumber.propTypes = {
	required: PropTypes.bool,
	helperText: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default SocialSecurityNumber;
